import { LegalLayout } from "../components/LegalLayout";

export function PrivacyPage() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Privacy Notice"
      lastUpdated="13 May 2026"
    >
      <h2>What we collect</h2>
      <p>We store only what's needed to run the service:</p>
      <ul>
        <li>
          <strong>Account</strong> — your email address, username, and a
          bcrypt hash of your password (never the password itself).
        </li>
        <li>
          <strong>Profile</strong> — anything you add to your public profile:
          name, designation, phone, address, web URL, social links, about text,
          uploaded images.
        </li>
        <li>
          <strong>Tokens</strong> — short-lived verification and
          password-reset tokens. They're invalidated after use.
        </li>
        <li>
          <strong>Timestamps</strong> — account created/updated. We don't
          track page views, mouse movements, or anything like that.
        </li>
      </ul>

      <h2>Why we use it</h2>
      <p>
        To authenticate you, render your public profile to visitors at
        <code> varo.biz/your-handle</code>, send transactional email
        (verification + password reset), and operate the service.
      </p>

      <h2>What we share</h2>
      <p>
        Nothing with marketers, advertisers, or data brokers — full stop. We
        rely on three infrastructure providers to run Varo:
      </p>
      <ul>
        <li>
          <strong>Render</strong> hosts the backend and the frontend, and runs
          our Postgres database.
        </li>
        <li>
          <strong>Cloudflare R2</strong> stores your uploaded images.
        </li>
        <li>
          <strong>Resend</strong> sends transactional email when you sign up
          or reset your password.
        </li>
      </ul>
      <p>
        Those providers process data on our behalf to operate the service.
        They don't have rights to use your data for their own purposes.
      </p>

      <h2>What's public</h2>
      <p>
        Anything on your public profile at <code>varo.biz/your-handle</code>
        is, well, public. That includes your name, designation, contact
        details, profile photo, social links, video, and about text — by
        design, because that's the whole point of a business card. Your
        email address and password are <strong>never</strong> public; your
        contact email shown on the public card is whatever you chose to
        publish.
      </p>

      <h2>Cookies and tracking</h2>
      <p>
        We use one localStorage entry (<code>varo.token</code>) to remember
        you're signed in. We don't use third-party analytics, ad pixels, or
        trackers. No "cookie banner" because there's nothing to consent to.
      </p>

      <h2>Your rights</h2>
      <p>
        You can edit or delete any field on your profile at any time from
        the editor. To export all your data or fully delete your account
        (including uploaded images), email{" "}
        <a className="uline" href="mailto:hello@varo.biz">
          hello@varo.biz
        </a>{" "}
        and we'll do it within 7 days.
      </p>

      <h2>Children</h2>
      <p>
        Varo isn't intended for users under 13. If we learn a sub-13 account
        exists, we'll delete it.
      </p>

      <h2>Migrated users</h2>
      <p>
        If your account was migrated from Mobilocard, the same privacy notice
        applies from the moment you next sign in. Your bcrypt-hashed password
        was carried over as-is — we never had access to the plaintext.
      </p>

      <h2>Changes</h2>
      <p>
        Material changes to this notice will be announced on your dashboard
        next time you sign in.
      </p>
    </LegalLayout>
  );
}
